import React from "react";
import "./ProgressBar.scss";

const ProgressBar = (props) => {
  const { progress, status } = props;
  
  // Treat these statuses as 100% complete since the main simulation computation is done
  const completionStatuses = ["finished", "resultUpload", "resultWriting", "postprocessing"];
  const isComplete = completionStatuses.includes(status);
  const displayProgress = isComplete ? 100 : progress;
  
  return (
    <div className="progress-bar-containter">
      <div
        className="progress-bar-filler"
        style={{
          width: `${displayProgress}%`,
        }}
      ></div>
      <span
        className="progress-bar-indicator"
        style={{
          color: `${
            displayProgress > 55 || isComplete ? "white" : "#424242"
          }`,
        }}
      >
        {displayProgress + "%"}
      </span>
    </div>
  );
};

export default ProgressBar;
